//格式化日期
function formatDate (date) {
  if (!date) {
    return '';
  }
  var date = new Date(Number(date + '000'));

  var YY = date.getFullYear() + '-';
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  //console.log(YY + MM + DD + " " + hh + mm + ss)
  return YY + MM + DD + " " + hh + mm + ss;
}

function formatDateAll (date) {
  if (!date) {
    return '';
  }
  var date = new Date(Number(date));

  var YY = date.getFullYear() + '-';
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  //console.log(YY + MM + DD + " " + hh + mm + ss)
  return YY + MM + DD + " " + hh + mm + ss;
}

// 获取子集全景相机id

function getChildIds (data) {
  let items = [];
  data.children ? getChild(data.children) : items.push(data);

  function getChild (data) {
    data.forEach(item => {
      if (item.children) {
        return getChild(item.children);
      } else {
        if (item.label.indexOf('全景相机') > 0) {
          items.push(item);
        }
      }
    })
  }
  return items;
}

//下载文件
function downloadFile (file, name = "我是文件", type, callback) {
  const blob = new Blob([file]);
  const fileName = `${name}.${type}`;
  if (!callback) {
    const linkNode = document.createElement("a");
    linkNode.download = fileName; //a标签的download属性规定下载文件的名称
    linkNode.style.display = "none";
    linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
    document.body.appendChild(linkNode);
    linkNode.click(); //模拟在按钮上的一次鼠标单击
    URL.revokeObjectURL(linkNode.href); // 释放URL 对象
    document.body.removeChild(linkNode);
  } else {
    callback(URL.createObjectURL(blob));
  }
}

//判断时间早晚
function compareDate (beginDate, endDate) {
  if (beginDate == endDate || !beginDate || !endDate) {
    return true;
  }
  return new Date(endDate.replace(/-/g, "/")) > new Date(beginDate.replace(/-/g, "/"))
}


export default {
  formatDateAll,
  formatDate,
  getChildIds,
  downloadFile,
  compareDate
}
